import { Directive, ElementRef, HostListener } from '@angular/core';
import { UtilityService } from '../../_services/utility.service';
import { environment } from '../../../environments/environment';

@Directive({
  selector: 'img'
})
export class ImageFallbackDirective {
  private hasFailed = false;

  constructor(
    private readonly el: ElementRef<HTMLImageElement>,
    private readonly utilityService: UtilityService
  ) {}

  @HostListener('error')
  onError(): void {
    if (this.hasFailed) {
      return;
    }
    this.hasFailed = true;

    const src = this.el.nativeElement.src;
    if (src.startsWith(environment.file)) {
      const originalPath = src.replace(environment.file, '');
      this.utilityService.markImageAsFailed(originalPath);
    }

    this.el.nativeElement.src = UtilityService.DEFAULT_IMAGE;
  }
}
